import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { fileSizeWarning: String };

  static get targets() {
    return ["value", "input"];
  }

  connect() {
    this.boundFormResetHandler = this.resetHandler.bind(this);
    this.valueTarget.form.addEventListener("reset", this.boundFormResetHandler);
    this.defaultLabel = this.valueTarget.placeholder; // Save initial placeholder as default label
  }

  display(evt) {
    let label = this.defaultLabel;

    if (evt.target.files.length > 0) {
      // Validate max file size of 10MB
      if (evt.target.files[0].size > 10 * 1024 ** 2) {
        alert(this.fileSizeWarningValue);
        evt.target.value = "";
      } else if (evt.target.multiple) {
        let fileNames = [];
        for (var i = 0; i < evt.target.files.length; ++i) {
          fileNames.push(evt.target.files.item(i).name.split("\\").pop());
        }
        label = fileNames.join(", ");
      } else {
        label = evt.target.value.split("\\").pop();
      }
    }

    this.setLabel(label);
  }

  // Update placeholder with selected file name
  setLabel(label) {
    if (this.valueTarget.nodeName == "INPUT") {
      this.valueTarget.placeholder = label;
    } else {
      this.valueTarget.innerHTML = label;
    }
  }

  resetHandler() {
    this.setLabel(this.defaultLabel);
  }

  disconnect() {
    this.valueTarget.form.removeEventListener("reset", this.boundFormResetHandler);
  }
}
